<div class="page-header">
  <h1>Tags</h1>
</div>

<div class="page-body">
  <tabset #tabs>
    <tab heading="Grille">
      <app-tags-by-users
        [defaultUserFilter]="selectedUser"
        [selectedTag]="selectedTag"
        [users]="users"
        [tags]="tags"
      ></app-tags-by-users>
    </tab>
    <tab heading="Tags">
      <app-tag-manager (onSelect)="showPeople($event)"></app-tag-manager>
    </tab>
  </tabset>
</div>
